import React from 'react'

class LoadingScreen extends React.Component {

  render(){
    const { style } = this.props
    return (
      <div style={style} className='design-loading-screen'>
        <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
        <span className='loading-text gray'>
          Wait a few seconds..
        </span>
      </div>
    )
  }

}

export default LoadingScreen